// extracted by mini-css-extract-plugin
module.exports = {"products":"suggestedProducts_products__GKDGa border-t border-solid border-subtle gap-3 grid pt-3"};